
// const urlBase = `${window.location.protocol}//${window.location.hostname}`;
// export const BASE_HOST = window.location.host.indexOf("localhost")!==-1 ? "http://localhost:5000" : urlBase;
// export const BASE_HOST = window.location.origin;

export const BASE_HOST = process.env.REACT_APP_API_URL;

export function getAPIKeyFromCookies(){
    return localStorage.getItem('accessToken');
}
export function getAccountAPIHeader(idToken){
    return {
    withCredentials: true,
    headers: {
      "Authorization": `Bearer ${idToken}`,
    }}
}